import { Col, Drawer, List, Menu, Row, Divider } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../Contexts/AuthContext';
import { useState } from 'react';
import SubMenu from 'antd/lib/menu/SubMenu';
import { MenuOutlined, PlusOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';
import { TextService } from '../../../Services/TextService';
import { getCurrentLanguage } from '../../../Helpers/RouteHelper';
import Cookies from 'universal-cookie';

const MobileDrawer = () => {
    const { user, logout } = useAuth();
    const navigation = useNavigate();
    const history = useLocation();
    const [showMobileDrawer, setShowMobileDrawer] = useState(false);
    const GetText = TextService.GetText;

    const showDrawer = () => {
        setShowMobileDrawer(true);
    };

    const hideDrawer = () => {
        setShowMobileDrawer(false);
    };


    const handleClick = async (key: string) => {

        if (key === "/logout") {
            await logout();
            navigation("/" + getCurrentLanguage() + "/logout");
        }
        else if (key === "/se" || key === "/en") {

            let oldNav = history.pathname.replace("/en", '');
            oldNav = oldNav.replace("/se", '');

            const cookies = new Cookies();
            cookies.set('language', key.replace("/", ''));
            navigation(key + oldNav);
        }
        else {
            navigation("/" + getCurrentLanguage() + key);
        }
        hideDrawer();
    };

    const getSelectedClass = (url: string) => {
        if ((window.location.pathname === "/" && url === "/Home") || window.location.pathname.indexOf(url) != -1) {
            return "mobile-navigation-item-selected";
        }

        return "";
    }

    if (user?.id != null) {
        return <>

            <div className="mobile-menu-drawer menu-right-align" onClick={showDrawer}>
                <MenuOutlined />
            </div>
            <Drawer
                placement="right"
                open={showMobileDrawer}
                onClose={hideDrawer}
                closable={false}
            >
                <List>
                    <List.Item onClick={opt => { handleClick("/") }} className={getSelectedClass("/")}> {GetText("TopHeader_Home")} </List.Item>
                    <List.Item onClick={opt => { handleClick("/CreateUser") }} className={getSelectedClass("/CreateUser")}> {GetText("TopHeader_CreateAccount")} </List.Item>
                    <List.Item onClick={opt => { handleClick("/Pricing") }} className={getSelectedClass("/Pricing")}> {GetText("TopHeader_Pricing")} </List.Item>
                    <List.Item onClick={opt => { handleClick("/Contact") }} className={getSelectedClass("/Contact")}> {GetText("TopHeader_Contact")} </List.Item>
                    <List.Item onClick={opt => { handleClick("/users") }} className={getSelectedClass("/users")}> {GetText("TopHeader_Users")}</List.Item>
                    <List.Item onClick={opt => { handleClick("/Settings") }} className={getSelectedClass("/Settings")}> {GetText("TopHeader_Settings")}</List.Item>

                    <List.Item onClick={opt => { handleClick("/logout") }} className={getSelectedClass("/Logout")}> {GetText("TopHeader_Logout")}</List.Item>

                    <Divider style={{ margin: '12px 0' }}>{GetText("TopHeader_Language")}</Divider>

                    <List.Item onClick={opt => { handleClick("/en") }} className={getSelectedClass("/en")}>{GetText("TopHeader_English")}</List.Item>
                    <List.Item onClick={opt => { handleClick("/se") }} className={getSelectedClass("/se")}>{GetText("TopHeader_Swedish")}</List.Item>
                </List>
            </Drawer>
        </>
    }
    else {
        return <>
            <div className="mobile-menu-drawer" onClick={showDrawer}>
                <MenuOutlined />
            </div>
            <Drawer
                placement="right"
                open={showMobileDrawer}
                onClose={hideDrawer}
                closable={false}
            >
                <List>
                    <List.Item onClick={opt => { handleClick("/") }} className={getSelectedClass("/")}> {GetText("TopHeader_Home")} </List.Item>
                    <List.Item onClick={opt => { handleClick("/CreateUser") }} className={getSelectedClass("/CreateUser")}> {GetText("TopHeader_CreateAccount")} </List.Item>
                    <List.Item onClick={opt => { handleClick("/Pricing") }} className={getSelectedClass("/Pricing")}> {GetText("TopHeader_Pricing")} </List.Item>
                    <List.Item onClick={opt => { handleClick("/Contact") }} className={getSelectedClass("/Contact")}> {GetText("TopHeader_Contact")} </List.Item>
                    <List.Item onClick={opt => { handleClick("/logout") }} className={getSelectedClass("/Login")}> {GetText("TopHeader_Login")}</List.Item>

                    <Divider style={{ margin: '12px 0' }}>{GetText("TopHeader_Language")}</Divider>

                    <List.Item onClick={opt => { handleClick("/en") }} className={getSelectedClass("/en")}>{GetText("TopHeader_English")}</List.Item>
                    <List.Item onClick={opt => { handleClick("/se") }} className={getSelectedClass("/se")}>{GetText("TopHeader_Swedish")}</List.Item>
                </List>
            </Drawer>
        </>
    }

};

export default MobileDrawer;